export * from './safeWindow'
